<template>
  <div class="auth">
    <div class="card auth__card">
      <h1 class="auth__title">{{ t("auth.verifyTitle") }}</h1>
      <p class="auth__lede muted small">{{ t("auth.verifyLede") }}</p>

      <div v-if="notice" class="notice notice--success auth__error">
        <div class="notice__body">{{ notice }}</div>
      </div>
      <div v-if="error" class="notice notice--danger auth__error">
        <div class="notice__body">{{ error }}</div>
      </div>

      <form v-if="!verified" class="stack" @submit.prevent="verify">
        <div class="field">
          <label class="field__label" for="email">{{ t("auth.email") }}</label>
          <div class="row">
            <input id="email" v-model.trim="email" class="input" type="email" autocomplete="username" required />
            <button type="button" class="btn btn--secondary" :disabled="busy || !email" @click="send">
              {{ sent ? t("auth.resend") : t("auth.sendCode") }}
            </button>
          </div>
        </div>
        <div class="field">
          <label class="field__label" for="otp">{{ t("auth.otp") }}</label>
          <input id="otp" v-model.trim="otp" class="input input--mono" inputmode="numeric"
                 autocomplete="one-time-code" maxlength="6" required />
        </div>
        <button class="btn btn--block" type="submit" :disabled="busy || otp.length < 6 || !email">
          <span v-if="busy" class="spinner" aria-hidden="true"></span>
          {{ t("auth.verifyAction") }}
        </button>
      </form>

      <p class="auth__foot small">
        <router-link to="/sign-in">{{ t("nav.signIn") }}</router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { authApi } from "../lib/api";
import { session, verifyEmailOtp } from "../lib/session";
import { useErrorText } from "../lib/errors";

const { t } = useI18n();
const errorText = useErrorText();
const router = useRouter();

const email = ref(session.user?.email || "");
const otp = ref("");
const sent = ref(false);
const verified = ref(false);
const busy = ref(false);
const error = ref("");
const notice = ref("");

async function run(fn) {
  busy.value = true;
  error.value = "";
  try {
    await fn();
  } catch (e) {
    error.value = errorText(e);
  } finally {
    busy.value = false;
  }
}

const send = () => run(async () => {
  await authApi.sendVerificationOtp(email.value);
  sent.value = true;
  notice.value = t("auth.otpSent", { email: email.value });
});

const verify = () => run(async () => {
  const signedIn = await verifyEmailOtp(email.value, otp.value);
  verified.value = true;
  if (signedIn || session.token) {
    router.push({ name: "apps" });
    return;
  }
  notice.value = t("auth.verifyDone");
});
</script>
